import React from 'react'
import { useCrmNavigation } from 'hooks/useCrmNavigation';
import { AssociatedContact } from './Deals/DealAssociation';
import UserAvatar from 'components/common/UserAvatar';


function ContactRow({ contact }: { contact: AssociatedContact }) {
  const { toViewContact } = useCrmNavigation();

  const handleClick = () => {
    if (!contact.contactKey) {
      console.warn(`ContactRow: missing contactKey for contact uuid=${contact.uuid}`)
      return
    }
    toViewContact(contact.contactKey)
  }

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleClick()
        }
      }}
      className="flex cursor-pointer items-center gap-3 rounded-xl border border-primary-subtle bg-primary-variant px-3 py-3 transition-colors duration-150 hover:border-neutral-medium/40 hover:bg-primary-subtle focus:outline-none focus-visible:border-neutral-medium/40"
    >
      <UserAvatar
        name={contact.name}
        profileImageURL={contact.profileImageUrl ?? undefined}
        className="w-9 h-9 text-xs"
      />
      <div className="min-w-0">
        <div className="truncate text-[14px] font-medium text-neutral">{contact.name}</div>
        {contact.email && (
          <div className="truncate text-[12.5px] text-neutral-faded">{contact.email}</div>
        )}
      </div>
    </div>
  );
}

export default ContactRow
